export function isBeta(): boolean {
  const url = window.location.href;
  const isBeta = url.includes("bridge-beta") || url.includes("localhost") || url.includes("127.0.0.1");
  return isBeta;
}

export function isProduction(): boolean {
  return !isBeta();
}
